import React, { useState, useEffect, useRef } from 'react';
import * as d3 from "d3";
import { checkValue } from '../utils/NumberUtils';
import { useHistory } from 'react-router-dom';
const ConsumpDailyGraph = (current) => {

    const [label] = useState([1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1])
    // const filteredData = current && current.daily && current.daily !== null && Object.keys(current.daily).length !== 0 ? current.daily.consumption_power.filter(data => typeof data === 'number') : [0, 0];
    const data = current && current.daily && current.daily !== null && Object.keys(current.daily).length !== 0 ? checkValue(current.daily.consumption_power) : [0, 0];
    const maxData = current.max;
    const history = useHistory();
    const pathname = history["location"].pathname
    const schoolId = Number(pathname.split('/').pop());

    const svgRef = useRef();

    useEffect(() => {
        const width = 135;
        const height = 50;
        const svg = d3.select(svgRef.current)
            .attr('width', width)
            .attr('height', height)
            .attr('transform', 'translate(20,0)')
            .style('overflow', 'visible')
            .style('color', '#fff')
            .style('font', '12px Inter')
            .style('font-weight', 'normal')
            .style('margin-top', '34px')
            .style('margin-left', '-20px')


        svg.selectAll("*").remove();

        const xScale = d3.scaleBand()
            .domain(label.map((val, i) => i))
            .range([0, width])
            .padding(0.2);

        const yScale = d3.scaleLinear()
            .domain([0, maxData ? maxData : 30000])
            .range([height, 0]);


        const yAxis = d3.axisRight(yScale)
        // .ticks(5)
        // .tickSize(-width);


        svg.selectAll('.bar')
            .data(label)
            .join('line')
            .call(drawLineBar);

        svg.selectAll('.bar')
            .data(data && data.length !== 0 ? data : 0)
            .join('line')
            .call(drawLineBar2);

        svg.append("text")
            .text("今日")
            .attr("x", 0)
            .attr("y", 65)
            .style('fill', '#084bb0')
            .style('font', '14px Inter')
            .style('font-weight', 'normal');

        svg.append("text")
            .text(maxData ? `${((maxData / 1000).toFixed(0))}kWh` : '10kWh')
            .attr("x", 133)
            .attr("y", 7)
            .style('font', '10px Inter')
            .style('fill', '#084bb0')
        // .style('font-weight', 'bold');

        svg.append("text")
            .text("0kWh")
            .attr("x", 133)
            .attr("y", 50)
            .style('fill', '#084bb0')
            .style('font', '10px Inter')
        // .style('font-weight', 'bold');

        svg.append("text")
            .text("消費電力情報")
            .attr("x", 0)
            .attr("y", -21)
            .style('fill', '#084bb0')
            .style('font', '16px Inter')
            .style('margin-bottom', '5px')
            .style('font-weight', 'normal');
        // .style('cursor', 'pointer')
        // .on("click", function () {
        //     history.push('/home/graph')
        // });

        svg.append("svg:image")
            .attr('xlink:href', '/img/consump_graph_arrow.png')
            .attr('x', 100)
            .attr('y', -37)
            .attr('width', 10.38)
            .attr('height', 20.42)
            .style('cursor', 'pointer')
            .on("click", function () {
                history.push(`/home/graph/${schoolId}`)
            });
        // svg.append('svg:image')
        //     .attr('xlink:href', '/img/arrow_up.png')
        //     .attr('x', 110)
        //     .attr('y', -48)
        //     .attr('width', 50)
        //     .attr('height', 25)


        function drawLineBar(g) {
            //customize label color 
            g.call(yAxis)
                .attr('x1', (v, i) => xScale(i))
                .attr('y1', (val) => yScale(val))
                .attr('x2', (v, i) => xScale(i))


                // .attr('y2', (val) => height)
                // .attr('stroke-dasharray', 1.5)
                .style('stroke', '#b4b2b2')
                .style('stroke-width', '4');
        }
        function drawLineBar2(g) {
            //customize color based on data
            g.call(yAxis)
                .attr('x1', (v, i) => xScale(i))
                .attr('y1', (val) => yScale(val))
                .attr('x2', (v, i) => xScale(i))
                .attr('y2', (val) => height)
                .style('stroke', '#084bb0')
                .style('stroke-width', '3')
        }
        // eslint-disable-next-line
    }, []);


    return (
        <svg ref={svgRef} id="weathergraph" />
    )
}
export default ConsumpDailyGraph;